import { createFileRoute } from '@tanstack/react-router';

import { NotificationsCenter } from '#features/notifications/components/NotificationsCenter';
import type { NotificationsTab } from '#features/notifications/model/notifications';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/notifications'
)({
  component: NotificationsCenter,
  ssr: false,
  validateSearch: (search: Record<string, unknown>): { tab?: NotificationsTab } => ({
    tab: search.tab === 'all' ? 'all' : undefined,
  }),
});
